/* format employee count and return a range string (such as '50 - 100') */
export const formatEmployeeCount = (data) => {
    let str = "N/A";
    if (data.min_num_emp && data.max_num_emp) {
        str = `${data.min_num_emp} - ${data.max_num_emp}`;
    } else if (data.min_num_emp && data.max_num_emp == 0) {
        str = `${data.min_num_emp}+`;
    }
    return (str);
}

/* format date founded and return in format MM/YYYY */
export const formatDateFounded = (data) => {
    let date = "N/A";
    // newDate(null) returns 1970-01-01
    // see https://stackoverflow.com/questions/49339980/why-new-datenull-is-returning-this-date-1970-01-01t000000-000z
    if (data.date_founded && data.date_founded !== '1970-01-01 00:00:00') {
        date = data.date_founded.substr(5, 2) + '/' + data.date_founded.substr(0, 4);
    }
    return (date);
}

/* 
    format boolean integer values where 1 = true, 0 = false and null = undefined / N/A
    this format is used for revenue_generating, is_active, etc.
*/
export const formatBooleanInteger = (val) => {
    let str = "N/A";
    if (val && val == 1) {
        str = 'Yes';
    } else if (val == 0) {
        str = 'No';
    }
    return (str);
}